import React, { useRef } from 'react';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';
import useOnclickOutside from 'react-cool-onclickoutside';
import StyledSearch from '../styles/Search';


const Search = ({ onKeyPress }) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });
  const ref = useRef();
  useOnclickOutside(ref, () => {
    clearSuggestions();
  });

  const handleInput = (e) => {
    setValue(e.target.value);
  };

  const handleSelect = ({ description }) => () => {
    setValue(description, false);
    clearSuggestions();

    getGeocode({ address: description })
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        onKeyPress(description, lat, lng);
      });
  };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <li key={id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });

  return (
    <StyledSearch ref={ref}>
      <input
        value={value}
        onChange={handleInput}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onKeyPress(e.target.value);
          }
        }}
        disabled={!ready}
        placeholder='Enter Location'
      />

      {status === 'OK' && <ul>{renderSuggestions()}</ul>}
    </StyledSearch>
  );
};

export default Search;
